import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const helpCenterLinkCss = "h1h9m7je";
export const HelpCenterLink = forwardRef((props, ref) => {
  const as = 'a';
  const href = 'https://calendly.com/help/abuse-prevention';
  const target = '_blank';
  const rel = 'noopener noreferrer';
  return <BareButton ref={ref} {...props} as={as} href={href} target={target} rel={rel} className={classNames(helpCenterLinkCss, props.className)} />;
});

require("./help_center_link.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./help_center_link.js");